export class TradeIdeasEnvironment {
  public static getName = () => 'benzinga-trade-ideas';
  public static getEnvironment = (env: Record<string, string>) => ({
    premiumUrl: new URL(env.premiumUrl ?? 'https://www.benzinga.com/research/api/'),
    url: new URL(env.url ?? 'https://www.benzinga.com/lavapress/api/'),
  });
}
